import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { AddStorePage } from './AddStorePage';
import { ArchivedStoresPage } from './ArchivedStoresPage';
import { StorePage } from './StorePage';
import { StoresPage } from './StoresPage';
import { StoreSettingsPage } from './StoreSettingsPage';
import { Inventory } from './Inventory';

export const Stores = () => {
    return (
        <div className="px-4 sm:px-8 lg:px-10 xl:px-12">
            <Switch>
                <Route exact path="/chain/stores" component={StoresPage} />
                <Route path="/chain/stores/create" component={AddStorePage} />
                <Route path="/chain/stores/archive" component={ArchivedStoresPage} />
                <Route path="/chain/stores/:slug/edit" component={StoreSettingsPage} />
                <Route path='/chain/stores/:slug/inventory' component={Inventory}/>
                <Route path="/chain/stores/:slug" component={StorePage} />
            </Switch>
        </div>
    );
};
